<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchShow" :gutter="16">
                <Col span="24">
                    <search-card
                        :form="mainTable.searchForm"
                        :table-load-event="getTableRecords"
                        :table-search="mainTable.tableSearch"
                    />
                </Col>
            </Row>
        </transition>
        <Card :padding="0" :bordered="false" :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                    <div class="global-tool-bar">
                        <div class="left-bar">
                            <span class="title"
                                >客户经理项目人部门成员列表</span
                            >
                        </div>
                        <div class="right-bar">
                            <Button
                                v-if="$checkAccessArray(['S'])"
                                size="small"
                                class="btns"
                                shape="circle"
                                type="success"
                                icon="ios-add-circle-outline"
                                @click="onCreate"
                                >新增(选择公司名称)</Button
                            >
                            <Button
                                v-if="$checkAccessArray(['S'])"
                                size="small"
                                class="btns"
                                shape="circle"
                                type="success"
                                icon="ios-add-circle-outline"
                                @click="onCreateWrite"
                                >新增(填写公司名称)</Button
                            >
                            <Button
                                type="primary"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-search"
                                @click="
                                    mainTable.sarchShow = !mainTable.sarchShow
                                "
                                >搜索</Button
                            >
                        </div>
                    </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                    <stand-pagination-table
                        :columns="mainTable.columns"
                        :data="mainTable.data"
                        :extHeight="60"
                        :loading="mainTable.loading"
                        :table-search="mainTable.tableSearch"
                        :table-load-event="getTableRecords"
                    />
                </Col>
            </Row>
        </Card>

        <DeptMemberCusMgrLeaderUpdate ref="DeptMemberCusMgrLeaderUpdateModal" />
        <DeptMemberCusMgrLeaderEdit ref="DeptMemberCusMgrLeaderModal" />
        <DeptMemberCusMgrLeaderEditWriteCompany
            ref="DeptMemberCusMgrLeaderEditWriteCompanyModal"
        />
    </div>
</template>

<script>
import SearchCard from "@/components/searchCard/searchCard.vue";
import search from "@/libs/search";
import StandPaginationTable from "@/components/standard-pagination-table/StandPaginationTable";
import { statusNewFormat } from "@/libs/baseModelFormat";
import { dateRender } from "@/libs/tableRowTimeRender";
import DeptMemberCusMgrLeaderUpdate from "./dept-member-cusMgrLeader-update";
import DeptMemberCusMgrLeaderEdit from "./dept-member-cusMgrLeader-edit";
import DeptMemberCusMgrLeaderEditWriteCompany from "./dept-member-cusMgrLeader-edit-write-company";
import { getProjectList } from "@/api/modules/account-management/inspector-user-management";

export default {
    name: "DeptMemberInspectorList",
    components: {
        SearchCard,
        StandPaginationTable,
        DeptMemberCusMgrLeaderUpdate,
        DeptMemberCusMgrLeaderEdit,
        DeptMemberCusMgrLeaderEditWriteCompany
    },
    data() {
        return {
            mainTable: {
                columns: [
                    {
                        title: "行号",
                        type: "index",
                        width: 60,
                        align: "center"
                    },
                    {
                        title: "公司名称",
                        key: "projectCompany",
                        align: "center"
                    },
                    {
                        title: "部门名称",
                        key: "projectName",
                        align: "center"
                    },
                    {
                        title: "成员账号",
                        key: "projectCode",
                        align: "center"
                    },
                    {
                        title: "成员姓名",
                        key: "userPersonName",
                        align: "center"
                    },
                    {
                        title: "成员手机号",
                        key: "userPhone",
                        align: "center"
                    },
                    {
                        title: "部门类型",
                        key: "projectType",
                        align: "center"
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "text",
                                            size: "small",
                                            shape: "circle"
                                        },
                                        style: {
                                            display: this.$checkAccessArray([
                                                "S"
                                            ])
                                                ? "inline"
                                                : "none"
                                        },
                                        on: {
                                            click: () => {
                                                this.onProjectUpdate(
                                                    params.row
                                                );
                                            }
                                        }
                                    },
                                    "编辑"
                                )
                            ]);
                        }
                    }
                ],
                data: [],
                sarchShow: false,
                searchForm: [
                    {
                        label: "公司名称",
                        type: "Input",
                        value: "",
                        name: "projectCompany",
                        sql: "like"
                    },
                    {
                        label: "部门名称",
                        type: "Input",
                        value: "",
                        name: "projectName",
                        sql: "like"
                    },
                    {
                        label: "账号/姓名",
                        type: "Input",
                        value: "",
                        name: "concat(projectCode, userPersonName)",
                        sql: "like"
                    },
                    {
                        label: "部门类型",
                        type: "Select",
                        name: "projectType",
                        sql: "in",
                        options: [
                            {
                                value: "市场部门",
                                key: "市场部门"
                            },
                            {
                                value: "非市场部门",
                                key: "非市场部门"
                            }
                        ]
                    }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        this.getTableRecords();
    },
    methods: {
        getTableRecords(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            this.mainTable.tableSearch.belongTo = "客户经理项目人";
            getProjectList(this.mainTable.tableSearch)
                .then((res) => {
                    if (res.code === 0) {
                        this.mainTable.data = res.data.records;
                        search.globalSetFilterRecordCount(
                            this.mainTable.tableSearch,
                            res.data.filterRecordCount
                        );
                    }

                    this.mainTable.loading = false;
                })
                .catch(() => {
                    this.mainTable.loading = false;
                });
        },
        onCreate() {
            this.$refs.DeptMemberCusMgrLeaderModal.showModal("");
        },
        onProjectUpdate(row) {
            this.$refs.DeptMemberCusMgrLeaderUpdateModal.showModal(row);
        },
        onCreateWrite() {
            this.$refs.DeptMemberCusMgrLeaderEditWriteCompanyModal.showModal(
                ""
            );
        }
    }
};
</script>

<style scoped></style>
